import { useState } from "react";
import { useNavigate } from "react-router-dom";

const DonorDiscoveryService = () => {
  const [expandedFaq, setExpandedFaq] = useState(0);
  const navigate = useNavigate();

  const toggleFaq = (index) => {
    setExpandedFaq(expandedFaq === index ? -1 : index);
  };

  return (
    <div className="flex flex-col items-center mt-36 mb-16 mx-4 sm:mx-8 lg:mx-16">
      {/* Hero Section */}
      <div className="w-full max-w-6xl text-center mb-16">
        <h1 className="text-5xl sm:text-6xl font-bold text-gray-800 mb-6 font-inter">
          Turn Anonymous Visitors into Passionate Supporters.
        </h1>
        <p className="text-lg text-gray-600 max-w-4xl mx-auto mb-8">
          With a single line of code, Sponsor a Pet reveals up to 40% of the
          people browsing your site—so you can turn silent traffic into donors,
          volunteers, and lifelong advocates.
        </p>
        <button
          onClick={() => {
            try {
              navigate("/contact-us");
            } catch (error) {
              window.location.href = "/contact-us";
            }
          }}
          className="bg-orange hover:bg-orange-600 text-white px-8 py-4 rounded-lg font-semibold text-lg"
        >
          Grow My Supporters List
        </button>
      </div>

      {/* Key Features Section */}
      <div className="w-full max-w-6xl mb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Person-Level Data */}
          <div className="text-center">
            <div className="w-16 h-16 bg-blue rounded-full flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-8 h-8 text-blue"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">
              Person-Level Data
            </h3>
            <p className="text-gray-600">
              B2B and B2C actionable contact information for targeted messaging.
            </p>
          </div>

          {/* Third-Party Opt-In Data */}
          <div className="text-center">
            <div className="w-16 h-16 bg-blue rounded-full flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-8 h-8 text-blue"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">
              Third-Party Opt-In Data
            </h3>
            <p className="text-gray-600">
              All data is compliant with U.S. laws and regulations, ensuring
              ethical and legal campaigns.
            </p>
          </div>

          {/* Built-In Retargeting */}
          <div className="text-center">
            <div className="w-16 h-16 bg-blue rounded-full flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-8 h-8 text-blue"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">
              Built-In Retargeting
            </h3>
            <p className="text-gray-600">
              Support for exporting data or using built-in retargeting for
              email, social, display, and direct mail campaigns from a unified
              dashboard.
            </p>
          </div>

          {/* No Cookies? No Problem */}
          <div className="text-center">
            <div className="w-16 h-16 bg-blue rounded-full flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-8 h-8 text-blue"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">
              No Cookies? No Problem
            </h3>
            <p className="text-gray-600">
              Advanced deterministic and probabilistic matching techniques
              identify visitors even on browsers that block cookies (like Safari
              and Firefox).
            </p>
          </div>
        </div>
      </div>

      {/* Efficient Ad Strategy Section */}
      <div className="w-screen -mx-4 sm:-mx-8 lg:-mx-16 bg-white py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-8 lg:px-16">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            <div className="lg:w-1/2">
              <h3 className="text-sm font-semibold text-blue uppercase tracking-wide mb-2">
                EFFICIENT AD STRATEGY
              </h3>
              <h2 className="text-4xl font-bold text-orange mb-6">
                Maximize Return on Ad Spend
              </h2>
              <p className="text-gray-600 text-lg mb-4">
                Boost the return on your paid ads by following up with visitors
                who don't convert immediately. Sponsor a Pet enables you to
                trigger direct mail, email, social media, and display ad
                campaigns automatically or manually, so that you never lose
                after a click.
              </p>
              <p className="text-gray-600 text-lg">
                For agencies managing large scale advertising efforts, this
                feature helps drive better results for their clients with
                minimal manual effort.
              </p>
            </div>
            <div className="lg:w-1/2">
              <div className="w-full h-80 rounded-lg overflow-hidden">
                <img
                  src="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/SAP+Consulting+Hi-Res+Images/3-donor-discovery/1-starski-graph.png"
                  alt="Efficient Ad Strategy - Analytics Dashboard"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Effortless Conversions Section */}
      <div className="w-screen -mx-4 sm:-mx-8 lg:-mx-16 bg-blue py-10">
        <div className="max-w-6xl mx-auto px-4 sm:px-8 lg:px-16">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            <div className="lg:w-1/2">
              <div className="w-full h-80 rounded-lg overflow-hidden">
                <img
                  src="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/SAP+Consulting+Hi-Res+Images/3-donor-discovery/2-starski-phone.webp"
                  alt="Effortless Conversions - Conversion Tools"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="lg:w-1/2">
              <h3 className="text-sm font-semibold text-white uppercase tracking-wide mb-2">
                EFFORTLESS CONVERSIONS
              </h3>
              <h2 className="text-4xl font-bold text-white mb-6">
                Convert More Traffic, Automatically.
              </h2>
              <p className="text-white text-lg">
                Sponsor a Pet automatically captures names, emails, and
                addresses from up to 40% of anonymous visitors without pop-ups
                or forms, ensuring seamless conversions for agencies or direct
                businesses.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Maximize SEO Impact Section */}
      <div
        className="w-screen -mx-4 sm:-mx-8 lg:-mx-16 py-5"
        style={{ backgroundColor: "#1b3a5d" }}
      >
        <div className="max-w-6xl mx-auto px-4 sm:px-8 lg:px-16">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            <div className="lg:w-1/2">
              <div className="w-full h-80 rounded-lg overflow-hidden">
                <img
                  src="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/SAP+Consulting+Hi-Res+Images/3-donor-discovery/3-starski-letter.png"
                  alt="Maximize SEO Impact - SEO Analytics"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="lg:w-1/2">
              <h3 className="text-sm font-semibold text-white uppercase tracking-wide mb-2">
                MAXIMIZE SEO IMPACT
              </h3>
              <h2 className="text-4xl font-bold text-orange mb-6">
                Get More ROI from SEO
              </h2>
              <p className="text-white text-lg">
                Already investing in content making? Don't let that organic
                traffic go to waste. Sponsor a Pet converts your website
                visitors into actionable leads by capturing contact information,
                so you can engage them through email, direct mail, and other
                personalized outreach methods.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Audience Insights Section */}
      <div className="w-screen -mx-4 sm:-mx-8 lg:-mx-16 bg-white py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-8 lg:px-16">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            <div className="lg:w-1/2">
              <h3 className="text-sm font-semibold text-blue uppercase tracking-wide mb-2">
                AUDIENCE INSIGHTS
              </h3>
              <h2 className="text-4xl font-bold text-orange mb-6">
                Learn More About Your Audience
              </h2>
              <p className="text-gray-600 text-lg">
                Enhance your campaigns with detailed demographic data, including
                insights like marital status, presence of children, automotive
                preferences, and more. This level of personalization helps
                agencies tailor campaigns for diverse client needs and empowers
                direct businesses to better understand and engage their
                audience.
              </p>
            </div>
            <div className="lg:w-1/2">
              <div className="w-full h-80 rounded-lg overflow-hidden">
                <img
                  src="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/SAP+Consulting+Hi-Res+Images/3-donor-discovery/4-starski-notepad.png"
                  alt="Audience Insights - Analytics Dashboard"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Multichannel Retargeting Platform Section */}
      <div className="w-full max-w-6xl mb-20">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-orange mb-6">
            Multichannel Retargeting Platform
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Place Pixel */}
          <div className="text-center">
            <div className="w-16 h-16 bg-blue rounded-full flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-8 h-8 text-blue"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">
              Place Pixel
            </h3>
            <p className="text-gray-600">
              Place the Sponsor a Pet pixel on your website.
            </p>
          </div>

          {/* Identify Visitors */}
          <div className="text-center">
            <div className="w-16 h-16 bg-blue rounded-full flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-8 h-8 text-blue"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">
              Identify Visitors
            </h3>
            <p className="text-gray-600">
              Sponsor a Pet leverages a network of match providers to convert
              your anonymous bounces into actionable leads.
            </p>
          </div>

          {/* Retarget Leads */}
          <div className="text-center">
            <div className="w-16 h-16 bg-blue rounded-full flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-8 h-8 text-blue"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">
              Retarget Leads
            </h3>
            <p className="text-gray-600">
              Use our integrated cross-channel remarking platform to nurture
              your leads.
            </p>
          </div>
        </div>
      </div>

      {/* Retarget Your Visitors Online and Offline Section */}
      <div className="w-full max-w-6xl mb-20">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-orange mb-6">
            Retarget Your Visitors Online and Offline
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Email */}
          <div className="text-center">
            <div className="w-16 h-16 bg-blue rounded-full flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-8 h-8 text-blue"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">Email</h3>
            <p className="text-gray-600">
              Email campaign manager with managed delivery to trigger email.
            </p>
          </div>

          {/* Direct Mail */}
          <div className="text-center">
            <div className="w-16 h-16 bg-blue rounded-full flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-8 h-8 text-blue"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm0 2h12v8H4V6z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">
              Direct Mail
            </h3>
            <p className="text-gray-600">
              Direct mail campaign manager with managed fulfillment to trigger
              direct mail.
            </p>
          </div>

          {/* Social */}
          <div className="text-center">
            <div className="w-16 h-16 bg-blue rounded-full flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-8 h-8 text-blue"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">Social</h3>
            <p className="text-gray-600">
              Social campaign manager allowing you to target your leads using
              custom audiences.
            </p>
          </div>

          {/* Display */}
          <div className="text-center">
            <div className="w-16 h-16 bg-blue rounded-full flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-8 h-8 text-blue"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">Display</h3>
            <p className="text-gray-600">
              Display campaign manager allowing you to target your leads using
              display ads.
            </p>
          </div>
        </div>
      </div>

      {/* Getting Started Section */}
      <div className="w-screen -mx-4 sm:-mx-8 lg:-mx-16 mb-0">
        <div className="relative w-full h-96 overflow-hidden">
          {/* Background image with overlay */}
          <div
            className="absolute inset-0 w-full h-full"
            style={{
              backgroundImage: `url('https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/SAP+Consulting+Hi-Res+Images/3-donor-discovery/5-xingchen-yan-NDOvSLRnDtU-unsplash.jpg')`,
              backgroundSize: "cover",
              backgroundPosition: "center center",
              backgroundRepeat: "no-repeat",
            }}
          ></div>
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>

          {/* Content */}
          <div className="relative z-10 flex h-full items-center">
            <div className="max-w-6xl mx-auto px-4 sm:px-8 lg:px-16">
              <div className="text-left">
                <h3 className="text-sm font-semibold text-white uppercase tracking-wide mb-2">
                  GETTING STARTED
                </h3>
                <h2 className="text-4xl font-bold text-white mb-6">
                  Start Reaching More Adopters, Volunteers, and Donors
                </h2>
                <button
                  onClick={() => {
                    try {
                      navigate("/contact-us");
                    } catch (error) {
                      window.location.href = "/contact-us";
                    }
                  }}
                  className="bg-orange hover:bg-orange-600 text-white px-8 py-4 rounded-lg font-semibold text-lg"
                >
                  Get Started
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
            <div className="lg:col-span-2 text-left">
              <p className="text-blue text-sm font-semibold uppercase tracking-wide mb-2">
                FREQUENTLY ASKED QUESTIONS
              </p>
              <h2 className="text-4xl font-bold text-orange">
                Common Questions About Donor Discovery
              </h2>
            </div>
            <div className="lg:col-span-3 space-y-4">
              {/* FAQ Item 1 */}
              <div className="border-b border-gray-200 pb-4">
                <button
                  onClick={() => toggleFaq(0)}
                  className="w-full text-left flex items-center justify-between py-2"
                >
                  <span className="text-gray-800 font-medium">
                    What is Donor Discover and how does it work?
                  </span>
                  <div className="w-6 h-6 flex items-center justify-center">
                    {expandedFaq === 0 ? (
                      <svg
                        className="w-4 h-4 text-gray-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M20 12H4"
                        />
                      </svg>
                    ) : (
                      <svg
                        className="w-4 h-4 text-gray-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        />
                      </svg>
                    )}
                  </div>
                </button>
                {expandedFaq === 0 && (
                  <p className="text-gray-600 mt-2 text-left">
                    Donor Discover identifies anonymous visitors to your website
                    and reveals their name, email address, and mailing address
                    using advanced tracking tools.
                  </p>
                )}
              </div>

              {/* FAQ Item 2 */}
              <div className="border-b border-gray-200 pb-4">
                <button
                  onClick={() => toggleFaq(1)}
                  className="w-full text-left flex items-center justify-between py-2"
                >
                  <span className="text-gray-800 font-medium">
                    How is this different from regular website analytics?
                  </span>
                  <div className="w-6 h-6 flex items-center justify-center">
                    {expandedFaq === 1 ? (
                      <svg
                        className="w-4 h-4 text-gray-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M20 12H4"
                        />
                      </svg>
                    ) : (
                      <svg
                        className="w-4 h-4 text-gray-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        />
                      </svg>
                    )}
                  </div>
                </button>
                {expandedFaq === 1 && (
                  <p className="text-gray-600 mt-2 text-left">
                    Unlike traditional analytics that only show aggregate data,
                    Donor Discover provides individual contact information for
                    each visitor, allowing for personalized follow-up campaigns.
                  </p>
                )}
              </div>

              {/* FAQ Item 3 */}
              <div className="border-b border-gray-200 pb-4">
                <button
                  onClick={() => toggleFaq(2)}
                  className="w-full text-left flex items-center justify-between py-2"
                >
                  <span className="text-gray-800 font-medium">
                    Can the data be filtered by engagement level?
                  </span>
                  <div className="w-6 h-6 flex items-center justify-center">
                    {expandedFaq === 2 ? (
                      <svg
                        className="w-4 h-4 text-gray-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M20 12H4"
                        />
                      </svg>
                    ) : (
                      <svg
                        className="w-4 h-4 text-gray-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        />
                      </svg>
                    )}
                  </div>
                </button>
                {expandedFaq === 2 && (
                  <p className="text-gray-600 mt-2 text-left">
                    Yes, you can filter visitors by their engagement level, time
                    spent on site, pages visited, and other behavioral metrics
                    to prioritize your outreach efforts.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Additional Services Section */}
      <div className="w-screen -mx-4 sm:-mx-8 lg:-mx-16 mb-0 bg-white py-20 pb-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
          <div className="text-left mb-12">
            <h3 className="text-sm font-semibold text-blue uppercase tracking-wide mb-2">
              ADDITIONAL SERVICES
            </h3>
            <h2 className="text-4xl font-bold text-orange mb-6">
              Discover More Services We Provide
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Website Redesign and SEO Relaunch */}
            <div className="relative rounded-lg overflow-hidden shadow-lg">
              <div
                className="w-full h-64 bg-cover bg-center"
                style={{
                  backgroundImage: `url('https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/SAP+Consulting+Hi-Res+Images/3-donor-discovery/6-lee-campbell-DtDlVpy-vvQ-unsplash.jpg')`,
                }}
              ></div>
              <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-70 text-white p-4">
                <h3 className="font-semibold">
                  Website Redesign and SEO Relaunch
                </h3>
              </div>
            </div>

            {/* Google Adwords Management */}
            <div className="relative rounded-lg overflow-hidden shadow-lg">
              <div
                className="w-full h-64 bg-cover bg-center"
                style={{
                  backgroundImage: `url('https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/SAP+Consulting+Hi-Res+Images/3-donor-discovery/7-david-brooke-martin-t_ZdxJsE8iM-unsplash.jpg')`,
                }}
              ></div>
              <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-70 text-white p-4">
                <h3 className="font-semibold">Google Adwords Management</h3>
              </div>
            </div>

            {/* Paid Search and SEO Integration */}
            <div className="relative rounded-lg overflow-hidden shadow-lg">
              <div
                className="w-full h-64 bg-cover bg-center"
                style={{
                  backgroundImage: `url('https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/SAP+Consulting+Hi-Res+Images/3-donor-discovery/8-charlesdeluvio-Dilfan21P8o-unsplash.jpg')`,
                }}
              ></div>
              <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-70 text-white p-4">
                <h3 className="font-semibold">
                  Paid Search (Google Ads) and SEO Integration
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DonorDiscoveryService;
